import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { localizer } from 'utils/localizer';
import { CustomForm, CustomInput, CustomButton } from 'modules/form';
import { resetPassword } from './ResetPasswordActions';
import SHA512 from 'crypto-js/sha512';

//import './LoginForm.css'

class ResetPasswordForm extends CustomForm {
    constructor(props) {
        super(props);
    }
    onSubmitHandler = () => {
        if (this.isFormValid()) {
            const form = this.serializeForm();
            const { password, confirm } = form;
            if (password !== confirm) {
                alert('Passwords do not match');
            } else {
                const obj = {};
                obj.password = SHA512(password).toString();
                obj.token = this.props.token;
                resetPassword(obj);
            }
        }
    };
    render() {
        return (
            <div className="forgot-password-form">
                <p>
                    Enter you new password below.
                    <br />
                    <br />
                </p>
                <CustomInput
                    name="password"
                    type="password"
                    label="New Password"
                    form={this}
                />
                <CustomInput
                    name="confirm"
                    type="password"
                    label="Confirm Password"
                    form={this}
                />
                <CustomButton
                    type="primary-button"
                    action={this.onSubmitHandler}
                    label="Reset Password"
                    loading={this.props.loading}
                />
            </div>
        );
    }
}

export default ResetPasswordForm;



// WEBPACK FOOTER //
// ./src/modules/onboarding/pages/reset-password/ResetPasswordForm.jsx